import { IconBriefcase } from "@tabler/icons-react";
import type { FC } from "react";
import { useLocation } from "react-router";
import { NavigationSearchContainer } from "../../../features/search/navigationSearchContainer.js";
import { matchesNavPath, NavigationMenu } from "./navigationMenu.js";
import type { NavigationMenuItemProps } from "./navigationMenuItem.js";

export const RecruitingNavigationMenu: FC = () => {
  const { pathname } = useLocation();

  const items: readonly NavigationMenuItemProps[] = [
    {
      label: "Job openings",
      href: "/",
      icon: <IconBriefcase aria-hidden className="size-4 shrink-0" />,
      // Also active on project detail routes, which belong to this section.
      isActive:
        matchesNavPath(pathname, "/") || matchesNavPath(pathname, "/project"),
    },
  ];

  return (
    <NavigationMenu
      items={items}
      search={<NavigationSearchContainer context="recruiting" />}
    />
  );
};
